import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Layout from '../../components/common/Layout/Layout';
import { BRAND } from '../../config/brand';
import './Account.css';

const SITE_URL   = BRAND?.url || process.env.REACT_APP_SITE_URL || 'https://theluviajewels.com';
const BRAND_NAME = BRAND?.name || 'Luvia';

function AccountOrderReturn() {
  const { orderId } = useParams();
  const canonicalUrl = orderId ? `${SITE_URL}/account/orders/${orderId}/return` : `${SITE_URL}/account/orders`;

  return (
    <Layout showFooter={true} showBottomTab={true}>
      <Helmet>
        <title>Return Request | {BRAND_NAME}</title>
        <meta name="description" content="Request a return or exchange for your order." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      
      <div className="account-page">
        <div className="account-container">
          <div className="account-header">
            <Link to={`/account/orders/${orderId}`} className="account-back">← Back to Order</Link>
            <h1 className="account-title">Return Request</h1>
            <p className="account-subtitle">Request a return or exchange for your order</p>
          </div>
          
          <div className="account-empty">
            <div className="account-empty__icon" aria-hidden="true">
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.2">
                <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
                <polyline points="7 10 12 15 17 10"/>
                <line x1="12" y1="15" x2="12" y2="3"/>
              </svg>
            </div>
            <p className="account-empty__title">Return Form Coming Soon</p>
            <p className="account-empty__sub">The return request form for order #{orderId?.slice(-8).toUpperCase()} will be available soon.</p>
            <Link to={`/account/orders/${orderId}`} className="account-empty__link">View Order Details →</Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default AccountOrderReturn;
